import {Element} from '@chaysehartsuff/active-html';

export default class AloText extends Element {

    rootTag = 'input';

    constructor(){
        super();
        this.addClass('w-full px-4 py-3 bg-gray-700/50 border border-gray-600/50 rounded-xl text-white');
        this.addClass('placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500/50 focus:border-gray-500/50');
        this.addClass('transition-all duration-300');
    }
}